import { ChevronDown } from "lucide-react";

type DropdownChevronProps = {
  isOpen?: boolean;
  disabled?: boolean;
  className?: string;
};

export default function DropdownChevron({
  isOpen = false,
  disabled = false,
  className = "",
}: DropdownChevronProps) {
  return (
    <ChevronDown
      aria-hidden="true"
      className={[
        "w-5 h-5 shrink-0 text-slate-500 transition-transform duration-300",
        isOpen ? "rotate-180" : "",
        disabled ? "opacity-50" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    />
  );
}
